import {useIntl} from "react-intl";
import {formatFileSize} from "../../../../utils/utils";
import {TitlePage} from "../../../shared";
import {useMemo, useState} from "react";
import {toast} from "react-toastify";
import {TorresstreamApi} from "../../../../apis/torrestream-api/torresstream-api";

const TorrentDownloadsTable = ({torrentsFiles}) => {
    const intl = useIntl();
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOption, setSortOption] = useState({field: "createdAt", order: "desc"});
    const [deletedTorrents, setDeletedTorrents] = useState([]);

    const handleDeleteFile = (fileId) => {
        if (window.confirm(intl.formatMessage({id: "torrents-dashboard.confirm-delete"}))) {
            TorresstreamApi.get("removeTorrentFile").call({torrentId: fileId})
                .then(() => {
                    setDeletedTorrents((prev) => [...prev, fileId]);
                    toast.success(intl.formatMessage({id: "torrents-dashboard.file-deleted"}));
                    console.log(`File with ID ${fileId} deleted successfully.`);
                })
                .catch((error) => {
                    console.error(`Error deleting file with ID ${fileId}:`, error);
                });
        }

    };

    const filteredTorrents = useMemo(() => {
        return torrentsFiles
            .filter((torrent) =>
                torrent.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
                !deletedTorrents.includes(torrent.id)
            )
            .sort((a, b) => {
                const fieldA = sortOption.field === "size" ? a.size : new Date(a.createdAt).getTime();
                const fieldB = sortOption.field === "size" ? b.size : new Date(b.createdAt).getTime();
                return sortOption.order === "asc" ? fieldA - fieldB : fieldB - fieldA;
            });
    }, [torrentsFiles, deletedTorrents, searchTerm, sortOption]);

    const totalSize = useMemo(() => {
        const size = torrentsFiles.filter(x => !deletedTorrents.includes(x.id)).reduce((total, torrent) => total + torrent.size, 0);
        return formatFileSize(size);
    }, [torrentsFiles, deletedTorrents]);

    return torrentsFiles.length > 0 && (
        <div className="mt-4">
            <TitlePage
                title={intl.formatMessage({id: "squadflix-home.downloaded-torrents"})}
                icon="fa-solid fa-floppy-disk"
                leftClass="col-9"
                rightClass="col-3"
                disableScroll
                hideSeparator
                rightOptions={<div>{totalSize}</div>}
                titleClass="mb-2 ps-1"
                fixedHeight="27px"
            />
            <div className="mb-3 d-flex justify-content-between">
                <input
                    type="text"
                    className="form-control me-2"
                    placeholder={intl.formatMessage({id: "torrents-dashboard.search"})}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <select
                    className="form-select"
                    value={`${sortOption.field}-${sortOption.order}`}
                    onChange={(e) => {
                        const [field, order] = e.target.value.split("-");
                        setSortOption({field, order});
                    }}
                >
                    <option value="createdAt-desc">
                        {intl.formatMessage({id: "torrents-dashboard.sort.date.desc"})}
                    </option>
                    <option value="createdAt-asc">
                        {intl.formatMessage({id: "torrents-dashboard.sort.date.asc"})}
                    </option>
                    <option value="size-desc">
                        {intl.formatMessage({id: "torrents-dashboard.sort.size.desc"})}
                    </option>
                    <option value="size-asc">
                        {intl.formatMessage({id: "torrents-dashboard.sort.size.asc"})}
                    </option>
                </select>
            </div>
            <table className="table table-striped table-hover">
                <thead>
                <tr>
                    <th>{intl.formatMessage({id: "torrents-dashboard.name"})}</th>
                    <th>{intl.formatMessage({id: "torrents-dashboard.stats"})}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {filteredTorrents.map((torrent) => (
                    <tr key={torrent.id}>
                        <td style={{verticalAlign: "middle"}}>{torrent.name}</td>
                        <td>
                            <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                                    <span className="badge text-bg-secondary">
                                        {formatFileSize(torrent.size)}
                                    </span>
                                <span className="badge text-bg-secondary">
                                        {new Date(torrent.createdAt).toLocaleDateString()}
                                    </span>
                            </div>
                        </td>
                        <td style={{verticalAlign: "middle"}}>
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDeleteFile(torrent.id)}
                            >
                                <i className="fa-solid fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default TorrentDownloadsTable;
